import React from 'react';
import './NOCServicesOffer.css';
import a from './img1.png';
import b from './img2.png';

const fitItems = [
    'עסקים שצריכים ניטור תשתיות ורשתות באופן רציף.',
    'חברות עם מערכות קריטיות שלא יכולות להרשות לעצמן Downtime.',
    'ארגונים שצריכים שיפור בזמני תגובה ופתרון תקלות.',
    'עסקים עם ריבוי מערכות, שרתים, סביבות ענן או רכיבי רשת.',
    'חברות שצריכות 24/7/365 בקרה ונראות טובה יותר.',
    'ארגונים בינוניים שצריכים שכבת NOC מקצועית בלי להקים צוות מלא פנימי.'
];

const problemItems = [
    'תקלות מתגלות מאוחר מדי.',
    'אין מספיק נראות בזמן אמת למה שקורה בתשתית או ברשת.',
    'יש תלות גבוהה במישהו שישים לב לתקלה.',
    'אין ניטור רציף מחוץ לשעות העבודה.',
    'יש יותר מדי רעש התראות אבל לא מספיק תגובה אפקטיבית.',
    'זמני תגובה ופתרון תקלות ארוכים מדי.',
    'אין תהליך הסלמה ברור.',
    'המערכות גדלו, אבל תהליכי התפעול לא גדלו איתן.'
];

const audienceSignals = [
    'אם אתם צריכים לדעת מה קורה בתשתית שלכם בזמן אמת.',
    'אם תקלות או עומסים מתגלים אצלכם מאוחר מדי.',
    'אם אתם רוצים לשפר זמינות ורציפות שירות בלי להעמיס על הצוות.',
    'אם יש לכם מערך מערכות ורשתות שדורש בקרה שוטפת.',
    'אם אתם צריכים שכבת ניטור ותגובה מקצועית מסביב לשעון.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הסביבה',
        text: 'ממפים את המערכות, רכיבי הרשת, התלותים והאתגרים התפעוליים.'
    },
    {
        number: '02',
        title: 'מיפוי ניטור ותהליכי תגובה',
        text: 'מגדירים נקודות קריטיות, התראות נדרשות ומסלולי הסלמה ברורים.'
    },
    {
        number: '03',
        title: 'בניית שכבת NOC',
        text: 'מקימים נוהל עבודה, בקרה שוטפת ותגובה מסודרת ברמות המתאימות.'
    },
    {
        number: '04',
        title: 'ניטור, תגובה ושיפור',
        text: 'ממשיכים לנטר, להגיב, לשפר ולהדק את הכיסוי התפעולי לאורך זמן.'
    }
];

const trustPoints = [
    'ניסיון בניטור, תשתיות, רשתות ותפעול שוטף.',
    'גישה פרקטית ולא תאורטית בלבד.',
    'חיבור בין זיהוי, תגובה ופתרון בפועל.',
    'מיקוד ביציבות, זמינות ושיפור רציף.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const NOCServicesOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-noc-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="noc-services-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">שירותי NOC וניטור לעסקים שצריכים שליטה, זמינות ותגובה מהירה</h2>
                        <p className="lead offer-description">
                            אנחנו מספקים ניטור רציף, זיהוי תקלות בזמן אמת, מענה תפעולי ושכבת
                            בקרה מקצועית שתעזור לכם לשמור על יציבות, רציפות שירות ותשתית שאפשר
                            לסמוך עליה.
                        </p>
                        <div className="noc-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאירו פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center noc-main-section">
                    <div className="col-md-6">
                        <h3>NOC הוא לא רק מסכים והתראות</h3>
                        <p>
                            המטרה היא לא רק לראות נתונים, אלא לזהות בעיות מוקדם, להגיב בזמן
                            ולצמצם פגיעה בשירות לפני שהמשתמשים מרגישים אותה.
                        </p>
                        <p>
                            ארגונים רבים גדלו מעבר לניטור אד-הוק. עכשיו הם צריכים נראות תפעולית
                            מסודרת יותר, זמני תגובה טובים יותר ושכבת בקרה אמינה סביב התשתית והרשת.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={b} alt="ניטור ודיאגנוסטיקה בזמן אמת" className="img-fluid" />
                    </div>
                </div>

                <div className="row align-items-center noc-secondary-section">
                    <div className="col-md-6">
                        <img src={a} alt="תגובה לאירועים, ניהול רשת ותפעול רציף" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו מספקים ניטור ודיאגנוסטיקה בזמן אמת, NOC פעיל 24/7/365, זיהוי
                            מוקדם של תקלות, עומסים ואנומליות, ותמיכה ותגובה ברמות Tier 1/2/3.
                        </p>
                        <p>
                            העבודה שלנו מחברת בין ניטור, תפעול ופתרון תקלות בפועל, כולל ניהול
                            תשתיות ורשתות, תהליכי הסלמה מסודרים ושיפור זמני תגובה ו-MTTR.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">ניטור ודיאגנוסטיקה בזמן אמת</div>
                            <div className="signal-item">NOC פעיל 24/7/365</div>
                            <div className="signal-item">זיהוי מוקדם של תקלות, עומסים ואנומליות</div>
                            <div className="signal-item">תמיכה ותגובה ברמות Tier 1/2/3</div>
                            <div className="signal-item">ניהול תשתיות ורשתות ותהליכי הסלמה ברורים</div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">מה יוצא לכם מזה</h3>
                            <div className="trust-grid">
                                <div className="trust-item">יותר נראות ושליטה תפעולית.</div>
                                <div className="trust-item">פחות השבתות וזיהוי מוקדם יותר של תקלות.</div>
                                <div className="trust-item">זמני תגובה ופתרון טובים יותר.</div>
                                <div className="trust-item">רציפות שירות גבוהה יותר.</div>
                                <div className="trust-item">פחות עומס על הצוות הפנימי.</div>
                                <div className="trust-item">סביבת תפעול שאפשר לסמוך עליה לאורך זמן.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם אתם לא רוצים לגלות תקלות מאוחר מדי, זה הזמן לעשות סדר</h3>
                            <p className="lead">
                                בואו נבין מה צריך לנטר, לייצב ולשפר כדי לבנות שכבת בקרה ותגובה אמינה יותר.
                            </p>
                            <div className="noc-cta-row">
                                <button
                                    type="button"
                                    className="btn btn-light btn-lg cta-btn"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-light btn-lg cta-btn"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <p className="cta-note">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NOCServicesOffer;
